import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import { type AxiosResponse } from "axios";
import { awsClientGateway } from "./common/gateway";
import { logMessage } from "../utils/amplifyLogger";
import { clientLog } from "./logging";

export interface ConnectedInstancePayload {
  instanceId: string;
  instanceUrl: string;
  arn: string;
  friendlyName: string;
  [key: string]: unknown;
}

//Action for selected instanceinfo from linkedlist
export const getConnectedInstance = createAction<ConnectedInstancePayload>(
  "instance/getConnectedInstance",
);

export const getUserInstance = createAsyncThunk<
  AxiosResponse | unknown,
  string
>("/instance-info", async (_userId: string, { rejectWithValue }) => {
  try {
    const response = await awsClientGateway({
      pathTemplate: "/instance-info",
      method: "POST",
    });
    return response;
  } catch (error) {
    clientLog({
      component: `instance`,
      message: `Something went wrong in getUserInstance API => ${error}`,
    });
    logMessage(
      `instance`,
      `Something went wrong in getUserInstance API => ${error}`,
      `error`,
    );
    return rejectWithValue("Error in getUserInstance api endpoint");
  }
});
